import { Injectable } from '@angular/core';
import { HttpClient, HttpParams  } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationFastapiService {
  private static USER_LOGIN_WITH_PASSWORDLESS_TOKEN_URL = '/user-login-with-passwordless-token';

  constructor(private httpClient: HttpClient) { }

  public loginWithPasswordlessToken(passwordlessToken: string) {
    const url = environment.fastapiExposedQuproAuthBaseURL + AuthenticationFastapiService.USER_LOGIN_WITH_PASSWORDLESS_TOKEN_URL;
    const params = new HttpParams().set('passwordless_token', passwordlessToken);
    return this.httpClient.get(url, { params });
  }
}
